<template>
   <div v-if="user">
     <button class="btn_bonus_widget" @click="show = true">
       <img src="/assets/img/bonus_star.svg" alt=""> {{parseInt(user.bonus_amount ?? 0)}}
     </button>
     <TheModal v-model:show="show">
       <div class="enter__body modal__body center">
         <h1>Бонусная карта</h1>
         <span> <img src="/assets/img/burgerboy_qr_phone.svg" alt=""> {{parseInt(user.bonus_amount ?? 0)}}Б</span>
         <div v-if="isLoading" class="skeleton-wrapper">
          <div class="skeleton-qr">
            <div class="skeleton-qr-inner"></div>
          </div>
          <div class="skeleton-text">
            <div class="skeleton-line skeleton-line--long"></div>
            <div class="skeleton-line skeleton-line--medium"></div>
            <div class="skeleton-line skeleton-line--short"></div>
          </div>
        </div>
        <div v-else-if="qrCode" style="text-align: center;">
           <img class="qr_img" width="216" height="216"  :src="qrCode" alt="">
           <p>{{user.firstname ?? 'Уважаемый пользователь'}}, покажите этот QR-код кассиру.
             Так мы идентифицируем Вас в программе, чтобы начислить и списать бонусы</p>

         </div>
         <button style="width: 100%; background: rgba(154, 43, 11, 0.12); color: rgba(154, 43, 11, 1); margin-top: 20px" class="btn" @click="show = false">Закрыть</button>
       </div>
     </TheModal>
   </div>
</template>

<script>
import TheModal from '@/components/TheModal.vue'
import {mapState} from "vuex";
import config from "@/config.js";
export default {
  name: 'BonusAccountModal',
  components: {TheModal},
  data() {
    return {
      show: false,
      isLoading: false,
      qrCode: null,
    }
  },
  computed:{
    ...mapState({
      'user': state => state.user.user,
    }),
  },
  watch: {
    show(newVal) {
      if (newVal && !this.qrCode) {
        this.loadBalanceQr();
      }
    }
  },
  methods: {
    async loadBalanceQr() {
      this.isLoading = true;
      await this.$API.request.get(config.hostname + '/index.php?route=api/customer/bonusBalanceQr', {
        headers: {
          'Content-Type': 'application/json',
        }
      }).then((response) => {
        this.qrCode = response?.qrcode ?? null;
      }).finally(() => {
        this.isLoading = false;
      })
    }
  }
}

</script>

<style lang="css" scoped>
    h1{
      font-family: BebasNeueProExpandedExtraBoldIt;
      font-size: 26px;
      font-weight: 800;
      line-height: 112%;
      margin-bottom: 40px;
    }
    .enter__body{
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    p{
      font-family: Jost;
      color: rgba(125, 124, 122, 1);
      font-weight: 400;
      font-size: 16px;
      line-height: 128%;
      letter-spacing: 0;
      text-align: center;

    }

    span{
      font-weight: 600;
      font-style: SemiBold;
      font-size: 40px;
      line-height: 94%;
      color: rgba(154, 43, 11, 1);
      display: flex;
      align-items: center;
      gap: 8px;

    }

    .qr_img{
      margin: 25px;
    }

    .btn_bonus_widget{
      background: rgba(154, 43, 11, 0.12);
      color: rgba(154, 43, 11, 1);
      font-family: Jost;
      font-weight: 600;
      font-style: SemiBold;
      font-size: 16px;
      line-height: 128%;

      padding: 8px 14px 8px 14px;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 7px;
    }

    /* Skeleton loader styles */
    .skeleton-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 25px;
      width: 100%;
    }

    .skeleton-qr {
      width: 216px;
      height: 216px;
      background: linear-gradient(135deg, #f0f0f0 25%, transparent 25%),
                  linear-gradient(225deg, #f0f0f0 25%, transparent 25%),
                  linear-gradient(45deg, #f0f0f0 25%, transparent 25%),
                  linear-gradient(315deg, #f0f0f0 25%, #e8e8e8 25%);
      background-size: 20px 20px;
      border-radius: 12px;
      position: relative;
      overflow: hidden;
      margin: 25px;
    }

    .skeleton-qr::before {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        90deg,
        transparent,
        rgba(255, 255, 255, 0.6),
        transparent
      );
      animation: skeleton-shimmer 1.5s infinite;
    }

    .skeleton-qr-inner {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 60px;
      height: 60px;
      background: #e0e0e0;
      border-radius: 8px;
    }

    .skeleton-text {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 8px;
      width: 100%;
      max-width: 280px;
    }

    .skeleton-line {
      height: 14px;
      background: linear-gradient(90deg, #f0f0f0 0%, #e8e8e8 50%, #f0f0f0 100%);
      background-size: 200% 100%;
      border-radius: 6px;
      animation: skeleton-shimmer-text 1.5s infinite;
    }

    .skeleton-line--long {
      width: 100%;
    }

    .skeleton-line--medium {
      width: 80%;
    }

    .skeleton-line--short {
      width: 50%;
    }

    @keyframes skeleton-shimmer {
      0% {
        left: -100%;
      }
      100% {
        left: 100%;
      }
    }

    @keyframes skeleton-shimmer-text {
      0% {
        background-position: 200% 0;
      }
      100% {
        background-position: -200% 0;
      }
    }
</style>
